var MenuId;

(function (MenuId) {
  MenuId["myProjects"] = "my-projects";
  MenuId["lists"] = "lists";
  MenuId["catalogChannel"] = "catalog-channel";
  MenuId["myChannels"] = "my-channels";
  MenuId["channel"] = "channel";
  MenuId["project"] = "project";
  MenuId["folder"] = "folder";
})(MenuId || (MenuId = {}));

export { MenuId };